import { createContext } from 'react'

import { Product } from '@Generated/graphql'

export const ProductContext = createContext<Product | undefined>(undefined)
